import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { PendingImportInterface, JobStatus } from "src/app/dtos/import-wizard/import-wizard.dto";
import { firstValueFrom } from "rxjs";
import { ImportWizardPendingService } from "@/app/pages/project/map/repository/import-wizard/components/pending-list/import-wizard-pending-list.service";

export const ImportJobGuard: CanActivateFn = async (route) => {
    const router = inject(Router);
    const importWizardPendingService = inject(ImportWizardPendingService);

    const jobId = route.paramMap.get("import_wizard_id");
    if (!jobId) {
        return router.createUrlTree(["/"]);
    }

    const job = await retrieveImportJob(jobId, importWizardPendingService);
    return verifyImportJob(job, jobId, router);
};

const verifyImportJob = (
    job: PendingImportInterface | null,
    jobId: string,
    router: Router
) => {
    if (!job) {
        return router.createUrlTree(["/"]);
    }
    if (job.status === JobStatus.UPLOADED) {
        const parentUrl = router.url.split(`/job`)[0];
        return router.createUrlTree([parentUrl]);
    }
    return true;
};

const retrieveImportJob = async (
    jobId: string,
    importWizardPendingService: ImportWizardPendingService
): Promise<PendingImportInterface | null> => {
    try {
        return await firstValueFrom(importWizardPendingService.getPendingImport(jobId));
    } catch (error) {
        return null;
    }
};